import { createStore } from 'effector';

import { ModalInterface } from 'services/ModalsService';

import { type RegisteredModals } from 'types/Modals';

type ModalsStore = { [key in RegisteredModals]?: ModalInterface | undefined };

export const $modals = createStore<ModalsStore>({});
